import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import classes from './styles.css'

class ConsentForms extends Component {

	render() {
		let formName = this.props.forms.map((form, index) => {
			return(
				<Link key={index} to={`/form/${index}`}>
					<li
						onClick={(e) => this.props.handleClickConsent(e.target.id)} 
						id={index}
					>{form.formName}</li>
				</Link>
			)
		})
		return (
			<ul className={classes.List}>{formName}</ul>
		)
	}
}

export default ConsentForms


// WEBPACK FOOTER //
// ./src/components/Forms/ConsentForms/ConsentForms.js